<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          UNIT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Unit List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search"
              single-line
              hide-details
              @keyup="searchUnit()"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              id="add-unit"
              @click="create()"
              depressed
              color="secondblue"
              class="white--text"
            >
              <v-icon left dark>add</v-icon>
              Add new unit
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="units"
          :search="search"
          :loading="loading"
          :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <!-- <v-data-table
          :headers="headers"
          :items="units"
          :search="search"
          :loading="loading"
          :must-sort="true"
        > -->
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.unit }}</td>
            </tr>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              :id="'btn-detail' + item.id"
              icon
              @click="edit(item)"
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-edit' + item.id"
              @click="deleteItem(item.id)"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="showDialog" id="showDialog" persistent max-width="450px">
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-0">
            <v-card-title class="primary white--text">
              <span class="pa-0">{{ isCreate ? 'Create' : 'Edit' }} Unit</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-0 pb-2">
                    <ValidationProvider
                      name="Name"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label>Name</label>
                      <v-text-field
                        v-if="isCreate"
                        single-line
                        outlined
                        dense
                        v-model="name"
                        placeholder="Name"
                        required
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                      <v-text-field
                        v-else
                        single-line
                        outlined
                        dense
                        v-model="itemDetail"
                        required
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-6 px-6">
              <v-spacer></v-spacer>
              <v-btn color="#bd1e19" dark @click="closeDialog()">
                Close
              </v-btn>
              <v-btn color="primary" dark type="submit">
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      loading: false,
      progressDialogLoading: false,
      search: '',
      isSearch: false,
      showDialog: false,
      isCreate: false,
      isEdit: false,
      id: null,
      name: '',
      itemId: '',
      itemDetail: '',
      totalItems: 0,
      descending: true,
      sort: '',
      options: {
        itemsPerPage: 5
      },
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Unit List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      headers: [
        {
          text: 'Name',
          value: 'unit'
        },
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      units: [
        {
          name: 'Box'
        }
      ],
      timeout: null
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchUnit() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    create() {
      this.showDialog = true;
      this.isCreate = true;
    },
    clear() {
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    closeDialog() {
      this.showDialog = false;
      this.isCreate = false;
      this.isEdit = false;
      this.name = '';
      this.clear();
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      const search = {
        unit: this.search
      };
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      this.$store
        .dispatch('unit/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          search
        })
        .then(data => {
          console.log(data);
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.units = data.data.result;
            this.totalItems = Number(data.data.total_data);
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    edit(item) {
      this.showDialog = true;
      this.isCreate = false;
      this.isEdit = true;
      this.itemId = item.id;
      this.itemDetail = item.unit;
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.isEdit) {
          const params = {
            unit: this.itemDetail
          };
          this.$store
            .dispatch('unit/update', { id: this.itemId, params })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.closeDialog();
                this.getData();
              } else {
                Swal.fire('Failed!', data.data.message.text_en, 'error');
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          const params = {
            unit: this.name
          };
          this.$store
            .dispatch('unit/create', params)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.closeDialog();
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this unit!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.$store.dispatch('unit/delete', id).then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Deleted!', data.message.text_en, 'success');
              this.clear();
              this.getData();
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Your unit data has been undeleted', 'error');
        }
      });
    }
  }
};
</script>
